import Color from 'color';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { OtherInformationField, Star, StarLink, SurveySubmitted, TagWrapper } from './components';
import { TagData } from './components/TagOptionsMap';

export type FiveStarSurveyComponentProps = {
  lastSelectedTag?: TagData;
  starRating: number;
  tags: TagData[];
  tagSelection: TagData[];
  onTagClick(tag: TagData): void;
  onCommentSend(message: string, otherTag: TagData): void;
  starClick(rating: number): void;
  otherTag?: TagData;
};

const commonStarAnalytics = {
  ActionId: 'StarClicked',
};

const SurveyHeading = styled.div`
  display: flex;
  padding: 10px;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: bold;
  text-align: center;
`;

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const StarContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

const StarRatingNumberSpan = styled.span`
  text-align: center;
  font-size: 13px;
  color: ${(props) => Color(props.theme.ob_colors.primary).alpha(0.7).string()};
  padding-top: 0.5rem;
`;

const StarRatingItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const SlideInContainer = styled.div`
  transition: all 3s 1s;
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: ${fadeIn};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TagContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const SurveyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const defaultSurveyTitle = 'How would you rate this guide?';

export const FiveStarSurveyComponent = ({
  otherTag,
  lastSelectedTag,
  starClick,
  starRating,
  tags,
  onTagClick,
  onCommentSend,
  tagSelection,
}: FiveStarSurveyComponentProps) => {
  const possibleScores = [1, 2, 3, 4, 5];
  
  return (
    <SurveyContainer>
      <SurveyHeading>{defaultSurveyTitle}</SurveyHeading>
      <StarContainer>
        {possibleScores.map((rating) => (
          <StarLink
            linkLabelText={`Rate ${rating} out of ${possibleScores.length}`}
            key={rating}
            rating={rating}
            onStarClicked={starClick}
            analyticsExtras={{ ...commonStarAnalytics, rating }}
          >
            <StarRatingItem aria-label={`Rate ${rating} out of ${possibleScores.length}`}>
              <Star color={starRating >= rating ? '#FFD600' : undefined} />
              <StarRatingNumberSpan>{rating}</StarRatingNumberSpan>
            </StarRatingItem>
          </StarLink>
        ))}
      </StarContainer>
      {tags && tags.length > 0 && (
        <SlideInContainer>
          <TagContainer>
            {tags.map((tag) => (
              <TagWrapper key={tag.displayText} tag={tag} tagSelection={tagSelection} onTagClick={onTagClick} />
            ))}
          </TagContainer>
        </SlideInContainer>
      )}
      {lastSelectedTag && !otherTag && <SurveySubmitted surveyText={lastSelectedTag.messageText} />}
      {otherTag && <OtherInformationField otherTag={otherTag} onCommentSend={onCommentSend} />}
    </SurveyContainer>
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/FiveStarSurveyComponent.tsx